import {
  CalibrationAccountingUnit,
  CalibrationLocation,
  CalibrationMeasurement,
  InProcessCalibration,
  PeriodicCalibration,
  PeriodicCalibrationDetail,
} from '@interfaces';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const calibrationActions = createActionGroup({
  source: 'Calibration API',

  events: {
    'Get Periodic Calibrations': props<{ companyId: string }>(),
    'Get Periodic Calibrations Success': props<{
      result: PeriodicCalibration[];
    }>(),
    'Toggle Periodic Calibration Loading': props<{ loading: boolean }>(),

    'Get Periodic Calibration By ID': props<{ id: string }>(),
    'Get Periodic Calibration By ID Success': props<{
      result: PeriodicCalibrationDetail[];
    }>(),
    'Clear Periodic Calibrations': emptyProps(),

    'Get In Process Calibrations': props<{
      equipmentId?: string;
      from?: Date;
      to?: Date;
      companyId?: string;
    }>(),
    'Get In Process Calibrations Success': props<{
      result: InProcessCalibration[];
    }>(),
    'Toggle In Process Calibration Loading': props<{ loading: boolean }>(),
    'Clear In Process Calibrations': emptyProps(),

    'Get Measurements Data': props<{
      orderId: number;
      articleId: string;
      batchId: string;
      orderPositionId: string;
    }>(),
    'Get Measurements Data Success': props<{
      result: CalibrationMeasurement[];
    }>(),
    'Toggle Measurements Data Loading': props<{ loading: boolean }>(),

    'Get In Process Calibration By ID': props<{ id: string }>(),
    'Get In Process Calibration By ID Success': props<{
      result: InProcessCalibration;
    }>(),
    'Toggle In Process Calibration By ID Loading': props<{
      loading: boolean;
    }>(),
    'Get Calibration Locations': emptyProps(),
    'Get Calibration Locations Success': props<{
      result: CalibrationLocation[];
    }>(),
    'Get Accounting Units': emptyProps(),
    'Get Accounting Units Success': props<{
      result: CalibrationAccountingUnit[];
    }>(),
  },
});
